module.exports = {"endpoint":""}


//////////////////
// WEBPACK FOOTER
// ./src/stores/fetchconfig.json
// module id = 39
// module chunks = 0